export default __webpack_public_path__ + "static/media/tai-po-geoheritage-centre.a7ed79da.jpg";